import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'nprogress/nprogress.css'
import Vuelidate from 'vuelidate'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueI18n from 'vue-i18n'
import config from './config.js'
import './assets/css/global.scss'
import './assets/css/backtest.scss'
import './assets/css/model-generator.scss'
import Echarts from 'echarts'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import filters from './filters'
import locale from 'element-ui/lib/locale/lang/en'
import Print from 'vue-print-nb'
import Hub from './hub'

library.add(fab, faCheckSquare, faCoffee)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

Vue.use(Print)
Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(ElementUI, { locale })
Vue.prototype.echarts = Echarts
Vue.prototype.$moment = moment
Vue.use(Echarts)
Vue.use(Hub)

// register global utility filters
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

store.dispatch('locale/initializeLocale')

const i18n = new VueI18n({
  locale: store.getters['locale/GetCurrentLocale'],
  fallbackLocale: 'en',
  messages: config.supported_languages,
  silentTranslationWarn: true
})

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    window.addEventListener('offline', () => {
      store.dispatch('SetConnected', false)
    })
    window.addEventListener('online', () => {
      store.dispatch('SetConnected', true)
    })

    const user = localStorage.getItem('user')
    if (user) {
      const userData = JSON.parse(user)
      this.$store.commit('user/SET_USER_DATA', userData)
    }
  },
  destroyed() {
    window.removeEventListener('offline')
    window.removeEventListener('online')
  }
}).$mount('#app')
